import { zodSchemes } from '@approvalmax/utils';
import { z } from 'zod';

import { messages } from './SelfieStep.messages';

export const schema = z
    .object({
        person: z
            .object({
                personDocuments: z
                    .object({
                        face: z.array(zodSchemes.fileRecord).nonempty({ message: messages.documentRequired }),
                    })
                    .passthrough(),
            })
            .passthrough(),
    })
    .passthrough();
